// extracted by mini-css-extract-plugin
export default {"watermarks":"styles_watermarks__O-Otz","imageContainer":"styles_imageContainer__Ol7aB","titleContainer":"styles_titleContainer__2l1zF"};